import React, { useState } from 'react'

import CategoryDisplay from './CategoryDisplay';
import CategoryEdit from './CategoryEdit';



const Category = (props) => {
    const { category, menuId, showIds } = props;


    const [isEdit, setIsEdit] = useState(false)

    const handleEdit = (flag) => {
        setIsEdit(flag);
    }

    return (
        <>
        { isEdit ? <CategoryEdit  menuId={menuId} category={category} editItem={handleEdit}/> :
         <CategoryDisplay menuId={menuId} category={category}  editItem={handleEdit} deleteCategory={props.deleteCategory} searchQuery={props.searchQuery}
         offShelfOnly={props.offShelfOnly} offShelfMap={props.offShelfMap} showIds={showIds}  />
    }
    </>
    );
};

export default Category;
